import { useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { getCustomerSuppliers } from '../../../Api/Customer/CustomerApi';

export interface Supplier {
  id: string;
  name: string;
}

export interface SupplierFilterParams {
  setCurrentSupplierId: (id: string) => void;
  currentSupplierId: string;
  customerId: string;
}

export const SuppliersFilter = ({ setCurrentSupplierId, currentSupplierId, customerId }: SupplierFilterParams) => {
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);

  const fetchSuppliers = async () => {
    if (currentSupplierId) setCurrentSupplierId('');
    const { data } = await getCustomerSuppliers(customerId);
    if (data) setSuppliers(data);
  };

  useEffect(() => {
    fetchSuppliers();
  }, [customerId]);

  if (suppliers.length === 0) return <></>;

  if (suppliers.length <= 4) {
    const defaultClass = 'enabled:hover:bg-gray-200 rounded text-sm py-2 px-5 disabled:opacity-25';
    const selectedClass = 'bg-grey-2 rounded text-sm py-2 px-5 disabled:opacity-25';

    return (
      <div className="flex flex-wrap gap-2">
        <button
          className={currentSupplierId == '' ? selectedClass : defaultClass}
          onClick={() => setCurrentSupplierId('')}>
          All Suppliers
        </button>
        {suppliers.map((supplier, index) => (
          <button
            key={index}
            className={currentSupplierId == supplier.id ? selectedClass : defaultClass}
            onClick={() => setCurrentSupplierId(supplier.id)}>
            {supplier.name}
          </button>
        ))}
      </div>
    );
  }

  return (
    <Select
      sx={{ m: 0, minWidth: 120, height: '35px', fontSize: '0.8rem' }}
      size="small"
      value={currentSupplierId}
      onChange={(e: SelectChangeEvent<string>) => setCurrentSupplierId(e.target.value)}
      displayEmpty
      inputProps={{ 'aria-label': 'Without label' }}>
      <MenuItem value="">All Suppliers</MenuItem>
      {suppliers.map((supplier, index) => (
        <MenuItem
          key={index}
          value={supplier.id}>
          {supplier.name}
        </MenuItem>
      ))}
    </Select>
  );
};
